module.exports = __webpack_public_path__ + "static/imc-4672f8b554bc904ce934e056d59516f5.png";